import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customPath": "/models/test-drive",
  "description": "Тест-драйв и обзоры моделей ŠKODA на официальном сайте Шкода в России",
  "huggerTemplate": "default",
  "keywords": "test-drive",
  "name": "test-drive",
  "title": "Тест-драйвы и обзоры автомобилей ŠKODA | Обзоры и тест-драйвы моделей Шкода"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const DefaultSectionHeading = makeShortcode("DefaultSectionHeading");
const DefaultSectionText = makeShortcode("DefaultSectionText");
const ShowRoomModelTilesQueried = makeShortcode("ShowRoomModelTilesQueried");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">ТЕСТ-ДРАЙВ МОДЕЛЕЙ ŠKODA</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    <p>
      Каждая семья – это целый уникальный мир, и для каждой семьи есть своя
      ŠKODA. Разнообразие семей и их образов жизни находит своё отражение в
      модельном ряду бренда, линейке оригинальных аксессуаров и SIMPLY CLEVER
      решениях.
    </p>
    <p>
      Чтобы лучше понять, какой именно автомобиль ŠKODA подойдет вашей семье, мы
      предлагаем вам записаться на тест-драйв в любой удобный официальный
      дилерский центр ŠKODA.
    </p>
    <p>
      Пройти тест-драйв можно всей семьей, чтобы и взрослые, и маленькие
      пассажиры, и даже питомцы, смогли по достоинству оценить автомобили ŠKODA,
      ведь мнение каждого члена семьи важно.
    </p>
  </DefaultSectionText>
  <ShowRoomModelTilesQueried tags="test-drive-2022" mdxType="ShowRoomModelTilesQueried" />
    </DefaultPaddedSection>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      